import { WarningIcon } from "@/components/icons";
import { AnchorIcon } from "@/components/icons/anchor-icon";
import { Button } from "@/components/ui/button";
import { GeneratedPricing } from "../../pricing-configurator.types";

type PricingPreviewProps = {
  generatedPricing: GeneratedPricing;
  anchorsCount: number;
  onReset: () => void;
};

export const CompiledPricingPointsPreview = ({ generatedPricing, anchorsCount, onReset }: PricingPreviewProps) => {
  const { points, warnings } = generatedPricing;

  return (
    <div className="h-full flex flex-col gap-4">
      <div className="flex items-center justify-between shrink-0">
        <div>
          <h3 className="text-sm font-medium">Aperçu</h3>
          <p className="text-xs text-muted-foreground">
            {anchorsCount} ancre{anchorsCount > 1 ? "s" : ""} → {points.length} point{points.length > 1 ? "s" : ""}{" "}
            généré{points.length > 1 ? "s" : ""}
          </p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={onReset} className="text-xs">
          Réinitialiser
        </Button>
      </div>

      {warnings.length > 0 && (
        <div className="flex gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-amber-800 dark:border-amber-800 dark:bg-amber-950/50 dark:text-amber-200 shrink-0">
          <WarningIcon className="h-4 w-4 shrink-0 mt-0.5" />
          <div className="space-y-1 text-xs">
            {warnings.map((warning, i) => (
              <div key={i}>{warning}</div>
            ))}
          </div>
        </div>
      )}

      {points.length > 0 && (
        <div className="flex-1 relative rounded-md border">
          <table className="w-full">
            <thead className="bg-muted/80">
              <tr>
                <th className="p-2 text-left text-xs font-medium text-muted-foreground">Durée</th>
                <th className="p-2 text-right text-xs font-medium text-muted-foreground">Prix</th>
              </tr>
            </thead>
            <tbody>
              {points.map((point, index) => (
                <tr key={index} className={`border-t ${point.isAnchor ? "bg-muted/30" : ""}`}>
                  <td className="p-2 text-sm">
                    <div className="flex items-center gap-2">
                      {point.duration} min
                      {point.isAnchor && (
                        <span className="rounded-full border border-primary bg-primary/10 px-1.5 py-0.5 text-[10px] font-medium text-primary flex items-center gap-1">
                          <AnchorIcon className="h-3 w-3" />
                          ancrage
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="p-2 text-right font-mono text-sm font-medium">{point.priceAmount.toFixed(2)} €</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {points.length === 0 && warnings.length === 0 && (
        <div className="flex-1 flex items-center justify-center rounded-md border border-dashed text-sm text-muted-foreground">
          Aucun point de tarification
        </div>
      )}
    </div>
  );
};
